import { render, staticRenderFns } from "./GroupDetailsModal.vue?vue&type=template&id=fe761aea&scoped=true"
import script from "./GroupDetailsModal.vue?vue&type=script&lang=js"
export * from "./GroupDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./GroupDetailsModal.vue?vue&type=style&index=0&id=fe761aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe761aea",
  null
  
)

export default component.exports